import Container from 'react-bootstrap/Container'

import ButtonCinestar from '../../../Buttons/ButtonCinestar/ButtonCinestar'
import Typography from '../../../Typography/Typography'

import { CINEMA_NAMES } from 'global/helpers/cinemaList'
import './CinemaSelect.scss'

const CinemaSelect = ({ toggleChooseCineama, chosenCinema }) => {
    const cinemaName = CINEMA_NAMES.find((cinema) => cinema.slug === chosenCinema)?.name
    return (
        <Container fluid className={'cinema-select d-flex'}>
            <Typography variant={'label'} color={'lighterPrimary'}>
                {'Vaše kino'}
            </Typography>
            <ButtonCinestar
                variant="secondary"
                iconRight="chevron–down"
                className="border-0 p-0"
                onClick={toggleChooseCineama}
            >
                {cinemaName}
            </ButtonCinestar>
        </Container>
    )
}

export default CinemaSelect
